import { defineMessages } from 'react-intl';

export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'search-respository-result.label',
		defaultMessage: 'Repository',
		description: 'Search respository label',
	},
});
